import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import TableContainer from '@mui/material/TableContainer';
import MuiDivider from '@mui/material/Divider';
import MuiFormControl from '@mui/material/FormControl';
import MuiAutocomplete from '@mui/material/Autocomplete';
import Typography from '@mui/material/Typography';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

export const PageContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  maxWidth: 1400,
  margin: '0 auto'
}));

export const HeaderSection = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3)
}));

export const ReportTypesGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
  gap: theme.spacing(3),
  marginBottom: theme.spacing(4)
}));

export const ReportTypeCard = styled(Card)(({ theme, selected, available = true }) => ({
  cursor: available ? 'pointer' : 'not-allowed',
  opacity: available ? 1 : 0.6,
  transition: 'all 0.2s ease-in-out',
  border: selected ? `2px solid ${theme.palette.primary.main}` : '2px solid transparent',
  '&:hover': {
    transform: available ? 'translateY(-4px)' : 'none',
    boxShadow: available ? theme.shadows[4] : 'none'
  }
}));

export const ComingSoonBadge = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  color: theme.palette.text.secondary
}));

export const ReportIconWrapper = styled(Box)(({ theme, color }) => ({
  width: 56,
  height: 56,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: color || theme.palette.primary.light,
  color: theme.palette.primary.contrastText,
  marginBottom: theme.spacing(2),
  '& svg': {
    fontSize: 28
  }
}));

export const ConfigSection = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3)
}));

export const FormRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  flexWrap: 'wrap',
  marginBottom: theme.spacing(2),
  alignItems: 'flex-start'
}));

export const ResultsSection = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3)
}));

export const ChartContainer = styled(Box)({
  height: 300,
  position: 'relative'
});

export const SiteSection = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2)
}));

export const SiteHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(2),
  flexWrap: 'wrap'
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  maxHeight: 400,
  marginTop: theme.spacing(2)
}));

export const ExcursionTypeChip = styled(Box)(({ type }) => {
  const colors = {
    temperature: { bg: '#ffebee', color: '#c62828' },
    humidity: { bg: '#e3f2fd', color: '#1565c0' },
    battery: { bg: '#fff3e0', color: '#ef6c00' }
  };
  const colorConfig = colors[type] || colors.temperature;

  return {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: 4,
    backgroundColor: colorConfig.bg,
    color: colorConfig.color,
    fontSize: '0.75rem',
    fontWeight: 500
  };
});

export const SummaryBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  marginBottom: theme.spacing(2),
  flexWrap: 'wrap'
}));

export const SummaryItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(1, 2),
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.shape.borderRadius,
  minWidth: 120
}));

export const ActionButtons = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2)
}));

export const StyledDivider = styled(MuiDivider)(({ theme }) => ({
  marginBottom: theme.spacing(2)
}));

export const ProjectAutocomplete = styled(MuiAutocomplete)({
  minWidth: 300
});

export const MonthFormControl = styled(MuiFormControl)({
  minWidth: 200
});

export const SectionTitle = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(3)
}));

export const BreakdownTitle = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(4)
}));

export const SmallChartContainer = styled(Box)({
  height: 200
});

export const ExcursionEventsTitle = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(1)
}));

export const SuccessIcon = styled(CheckCircleOutlineIcon)(({ theme }) => ({
  fontSize: 40,
  marginBottom: theme.spacing(1)
}));
